<template>
  <div class="hello" >
      <!-- 右侧浮框 -->
      <div class="index_tips" v-if="$store.state.isShow" >
          <div class="index_center">
              <div class="index_center_box">
                  <div class="index_center_qq" @click="talk"><i></i>在线客服</div>
                  <div class="index_center_phone"><i></i>400-188-9318</div>
              </div>
          </div>
          <div class="index_goback" v-show="show">
            <div class="goback" @click="gotop">返回顶部</div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    talk() {
      window.open(
        "http://wpa.qq.com/msgrd?v=3&uin=974089624&site=qq&menu=yes",
        "_brank"
      );
    },
    gotop() {
      this.$emit("gotop");
    }
  }
};
</script>

<style lang="scss" scoped>
.index_tips {
  position: fixed;
  bottom: 100px;
  right: 24px;
  z-index: 1000;
  .index_center:hover .index_center_box {
    display: block;
  }
  .index_center {
    background: #fff url("~@/assets/index/service.png") no-repeat center center;
    background-size: 24px 24px;
    width: 24px;
    height: 24px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    padding: 8px;
    margin-bottom: 8px;
    position: relative;
    .index_center_box {
      position: absolute;
      right: 23px;
      top: -16px;
      background: url("~@/assets/index/Combined Shape (1).png") no-repeat center
        center;
      background-size: 213px 153px;
      width: 156px;
      height: 153px;
      padding-left: 24px;
      padding-right: 33px;
      display: none;
      .index_center_qq {
        line-height: 20px;
        font-size: 14px;
        color: #222222;
        padding-bottom: 15px;
        border-bottom: 1px solid #eeeeee;
        padding-top: 32px;
        padding-left: 16px;
        cursor: pointer;
        i {
          display: inline-block;
          width: 20px;
          height: 20px;
          vertical-align: top;
          margin-right: 8px;
          background: url("~@/assets/index/QQ.png") no-repeat center center;
        }
      }
      .index_center_qq:hover {
        color: #2e54eb;
      }
      .index_center_phone {
        padding: 16px;
        line-height: 20px;
        font-size: 14px;
        color: #222222;
        i {
          display: inline-block;
          width: 20px;
          height: 20px;
          vertical-align: top;
          margin-right: 8px;
          background: url("~@/assets/index/phones.png") no-repeat center center;
        }
      }
    }
  }
  .index_goback {
    background: #fff url("~@/assets/index/fold.png") no-repeat center center;
    background-size: 24px 24px;
    position: relative;
    width: 24px;
    height: 24px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    padding: 8px;
    margin-bottom: 8px;
    .goback {
      background: url("~@/assets/index/Combined Shapes.png") no-repeat center
        center;
      background-size: 158px 88px;
      width: 102px;
      height: 62px;
      position: absolute;
      right: 23px;
      top: -16px;
      padding-top: 26px;
      padding-left: 48px;
      font-size: 14px;
      color: #fff;
      display: none;
      cursor: pointer;
    }
  }
  .index_goback:hover {
    background: #2e54eb url("~@/assets/index/folds.png") no-repeat center center;
    background-size: 24px 24px;
    .goback {
      display: block;
    }
  }
}

@media screen and (max-width: 750px) {
  .index_center {
    display: block !important;
    // width: 50px !important;
    // height: 50px !important;
    // background: #ffffff url("~@/assets/index/service-blue.png") no-repeat center
    // center !important;
    // background-size: 40px 40px !important;
    // box-shadow: 0px 4px 8px 0px rgba(46, 84, 235, 0.16) !important;
    // border-radius: 40px !important;
    // border: 2px solid #eeeeee !important;
    // margin-bottom:50px !important;
  }
  // .index_center_box {
  //   right: 60px !important;
  //   top: 8px !important;
  //    background-size:  100px 200px !important;
  //   width: 200px !important;
  //     height: 300px !important;
  // }
}
</style>





// WEBPACK FOOTER //
// src/components/com-float.vue